var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332102 2.66602C0.332102 1.56145 1.22753 0.666016 2.3321 0.666016H11.6654C12.77 0.666016 13.6654 1.56145 13.6654 2.66602V3.32234C13.6655 3.32883 13.6655 3.33532 13.6654 3.3418V9.33268C13.6654 10.4373 12.77 11.3327 11.6654 11.3327H2.3321C1.22753 11.3327 0.332102 10.4373 0.332102 9.33268V3.3418C0.332008 3.33532 0.332008 3.32883 0.332102 3.32234V2.66602ZM1.66544 4.57836V9.33268C1.66544 9.70087 1.96391 9.99935 2.3321 9.99935H11.6654C12.0336 9.99935 12.3321 9.70087 12.3321 9.33268V4.57836L8.10817 7.39432C7.43637 7.84218 6.56117 7.84218 5.88937 7.39432L1.66544 4.57836ZM12.3321 2.97589L7.36857 6.28491C7.14464 6.4342 6.8529 6.4342 6.62897 6.28491L1.66544 2.97589V2.66602C1.66544 2.29783 1.96391 1.99935 2.3321 1.99935H11.6654C12.0336 1.99935 12.3321 2.29783 12.3321 2.66602V2.97589Z",
    fill: "#31B9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.79b8b933c488de7b5dfcab11e56e0973.svg";
export { ForwardRef as ReactComponent };